import { useTranslation } from 'react-i18next';
import classes from './Banner.module.scss';
import Button from '../../GlobalComponents/Button/Button';

const Banner = () => {
    const { t } = useTranslation();
    return (
        <section className="container">
            <div className={classes.wrap}>
                <div className={classes.content}>
                    <div className={classes.head}>
                        <h1 className={`${classes.title} font-48`}>
                            {t('portfolio.banner.title')}
                        </h1>
                        <h2 className={`${classes.subtitle} font-40`}>
                            {t('portfolio.banner.subtitle')}
                        </h2>
                    </div>
                    <p className={`${classes.text} font-16`}>
                        {t('portfolio.banner.text')}
                    </p>
                    <p className={`${classes.desc} font-20`}>
                        {t('portfolio.banner.desc')}
                    </p>
                    <div className={classes.btn}>
                        <Button white form>
                            {t('btn.consultation')}
                        </Button>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Banner;
